export const applicationId = 'cbd43ef0-8758-45be-a89b-8ada8f981ae7';

// export const UNO_URL = 'http://localhost:3003';
export const UNO_URL = 'https://api.simulanis.io';
// export const UNO_URL = 'https://simulanis-uno-backend-backup-uat.azurewebsites.net';

export const SECRET_KEY = "uxbA5VlmZ=dcdzMk^%gIw?&N<P";

export const SSO_URL = "https://sso.simulanis.io";
// export const SSO_URL = "http://192.168.1.136:5000";

export const CHANNEL_ID = "ac1765fe-cd99-46ee-a567-f747f4f3c61f";

export const moduleFilterId = 1;
export const applicationCategoryId = 8;
export const environmentFilterId = 88;

export const industryCategoryId = 1;
export const entityCategoryId = 2;

export const categoryIds = {
    INDUSTRIES: 1,
    ENTITY: 2,
    USE_CASE: 18,
    TRAINING: 19,
    GUIDANCE: 20,
    COLLABORATION: 21,
    SIMULATORS: 22,
    SALE_TYPES: 23
}